import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AllItems from "../components/Views/AllItems.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import Entity from "../datasource/Entity";

import Container from "./Container.jsx";

class MarketGroupContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("market_groups");
    }

    getBackLink = () => this.datasource.routes().home;

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title={"Список торговых групп"}
                        columns={{
                            id: "Id",
                            name: "Имя",
                            description: "Описание",
                            code: "Код",
                            active: "Активен",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                        toggleAction={this.toggleItem}
                        removeAction={this.removeItem}
                        getHotelsAction={this.getHotelsData}
                        hotelsData={this.state.hotelsData}
                        fields={fields}
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новая торговая группа"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        title="Редактирование торговой группы"
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        submitActionApply={this.updateItemWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                    />
                </Route>
            </Switch>
        );
    };
}

export default MarketGroupContainer;
